import React from 'react';
import css from './WineCard.module.css';
import wine1 from './wine1.png'
import { InlineTextButton, NamedLink, ResponsiveImage } from '../../../../components';
import Bottle from '../../../../components/review/Bottle';
import { createSlug } from '../../../../util/urlHelpers';
import { formatMoney } from '../../../../util/currency';

function WineCard({wine, intl}) {
  const wineTitle = wine?.attributes.publicData.vintage + " " + wine?.attributes.title;
  const formattedPrice = formatMoney(intl, wine?.attributes.price);

  const firstImage =
    wine.images && wine.images.length > 0 ? wine.images[0] : null;

  // title text greater than 45 extract it:
  const title = str => str && str.length > 45 ? str.slice(0, 32) + '...' : str;

  return (
    <div className={css.wineCardContainer}>
      <div className={css.wineCardWrapper}>
        <NamedLink name="WinePage" params={{slug: createSlug(wine?.attributes.title), id: wine?.id.uuid}}>
          <div className={css.wineCardImgWrapper}>
            <ResponsiveImage
                rootClassName={css.rootForImage}
                alt={wineTitle}
                image={firstImage}
                variants={['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge']}
                sizes="(max-width: 767px) 100vw, 80vw"
              />
          </div>
        </NamedLink>

        <h1>{title(wineTitle)}</h1>
        {/* <div className={css.cardBottleReview}>
          {[1, 2, 3, 4, 5].map((_, index) => (
            <Bottle />
          ))}
        </div> */}
        <h3 >{wine?.attributes.publicData.wineryName}</h3>
        <h5>{formattedPrice}</h5>
      </div>
      <NamedLink className={css.cardBtn} name="WinePage" params={{slug: createSlug(wine?.attributes.title), id: wine?.id.uuid}}>
        View Details
      </NamedLink>
    </div>
  )
}

export default WineCard
